import React from 'react'
import { useTranslation } from 'next-i18next'
import { MePayoutTransactionDetail } from '../../../../../../types/Payout/MePayoutTransactionDetail'
import PayoutTransactionDetailsTabElem from './PayoutTransactionDetailsTabElem'

interface PayoutTransactionDetailsTabProps {
  payoutTransactionDetails?: MePayoutTransactionDetail[]
}

export default function PayoutTransactionDetailsTab({
  payoutTransactionDetails,
}: PayoutTransactionDetailsTabProps) {
  const { t } = useTranslation('dashboard')

  return (
    <div className="flex max-h-48 flex-col">
      {payoutTransactionDetails && payoutTransactionDetails.length > 0 ? (
        payoutTransactionDetails.map((detail, index) => (
          <div key={index}>
            <PayoutTransactionDetailsTabElem payoutTransactionDetail={detail} />
          </div>
        ))
      ) : (
        <div className="flex h-full items-center justify-center p-3">
          <p className="text-center text-sm text-gray-600">
            {t(
              'payoutsReview.tabDetails.transactionDetails.tab.errors.nothingFound',
            )}
          </p>
        </div>
      )}
    </div>
  )
}
